var ei = {
  Tn: function Tn(t) {
    var r = (t + "=".repeat((4 - t.length % 4) % 4)).replace(/\-/g, "+").replace(/_/g, "/"),
      n = atob(r),
      o = new Uint8Array(n.length);
    for (var _t = 0; _t < n.length; ++_t) o[_t] = n.charCodeAt(_t);
    return o;
  }
};
export default ei;